export const SALDO_INICIAL = '1'
export const ADICIONES = '2'
export const MEJORAS = '3'
export const RETIROS = '4'
export const OTROS = '5'

